import EventNoteIcon from "@mui/icons-material/EventNote";
import { INDIVIDUAL_SLOTS, GraduationServicePath, SCHEDULES } from "utils/constants";
import permissions from "app/permissions";
import ListScheduleIndividualSlot from "./List";
import CreateScheduleIndividualSlot from "./Create";
import ShowScheduleIndividualSlot from "./Show";
import EditScheduleIndividualSlot from "./Edit";

export const resources = {
  isMenu: true,
  icon: <EventNoteIcon />,
  name: GraduationServicePath + SCHEDULES + "/" + INDIVIDUAL_SLOTS,
  title: "Разписание - Индивидуално ",
  list: <ListScheduleIndividualSlot />,
  create: <CreateScheduleIndividualSlot />,
  edit: <EditScheduleIndividualSlot />,
  show: <ShowScheduleIndividualSlot />,
  permission: permissions.canPreviewInternshipSchedules,
};
